export { default as InfoBlock } from './InfoBlock'
